import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import SettingsPage from 'flarum/forum/components/SettingsPage';

export default () => {
  extend(SettingsPage.prototype, 'settingsItems', function (items) {
    items.remove('account'); // Email & Password must be managed through Customer Profile
  });
};
